module.exports = __webpack_public_path__ + "static/img/product-poster-5.9828ed7c.png";